import { useAppContext } from '../../appProvider/contextProvider'


const WebsiteDropDown  = () => {

    const {websites, setSelectedWebsite, selectedWebsite } = useAppContext();

     const onChangeSelection = (_url) => {
        const selectedWebsite = websites.find(({url}) => url === _url);
        setSelectedWebsite(selectedWebsite);
    }

    return <>
        <div className="form-group d-block d-sm-none">
            <div className="custom-select custom-select-icon">
                <i className="icon icon-website"></i>
                <select value={selectedWebsite ? selectedWebsite.url : ''} onChange={({target}) => onChangeSelection(target.value)}  className="form-control">
                    { 
                        websites.length && websites.map((website, index) => <option value={website.url}  key={index}>{website.url}</option>)
                    }
                </select>
            </div>
        </div>
    </>
}


export default WebsiteDropDown;